import { useState } from "react";
import React from "react";
import axios from "axios";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './Insuranceform.css'
import ThankYouPage from "./ThankYouPage";
import { useSelector } from 'react-redux';
import {
  updateDOB,
  updateFirstName,
  updateLastName,
  updateGender,
  updateSmoke,
  updateMobileNo,
  updateEmail,
  updateSbgGroup,
  updateState
} from '../formSlice';
// console.log(updateFormField , "test")








function Insuranceform({ handlesubmit }) {

  const [sumAssured, setSumAssured] = useState(10000000);
  const [policyTerm, setPolicyTerm] = useState(52);
  const [paymentFrequency, setPaymentFrequency] = useState('Yearly');
  const [payingOption, setPayingOption] = useState('Regular');
  const [premiumTerm, setPremiumTerm] = useState(52);
  const [selectedPlan, setSelectedPlan] = useState('rdolevelCoverAndFutureBenefits');
  const { annualIncome, dob, firstName, lastName, gender, smoke, mobileNo, email, sbgGroup, state } = useSelector(state => state.form);
  const dummydata = {
    annual_income: annualIncome,
    date_of_birth: dob,
    first_name: firstName,
    last_name: lastName,
    gender: gender,
    smoker: smoke,
    mobile_number: mobileNo,
    email: email,
    spouse_employment: sbgGroup,
    state: state
  };












  const handlePlanChange = (e) => {
    setSelectedPlan(e.target.value);
    console.log('Selected Plan:', e.target.value);
  };

  const convertNumberToWords = (num) => {
    return num.toString();
  };

  return (
    <>
      <div className="card bg-white card-post-quote px-lg-4 px-0 pb-3">
        <div className="card-body">
          <div className="row justify-content-between">
            <div className="col-md-6 col-sm-12 mb-4">
              <div className="content-details mb-0">
                <label className="label label-info-lg mb-2" htmlFor="e_shield_sum_assured">
                  Sum Assured
                </label>
                <div className="d-flex justify-content-between">
                  <span className="pre-label lato-regular font-weight-regular font-12 lh-15 text-gradient mb-1">
                    Min-50 lakh
                  </span>
                </div>
                <div className="form-data">
                  <div className="form-group position-relative">
                    <input
                      type="text"
                      value={sumAssured}
                      onChange={(e) => setSumAssured(e.target.value)}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) e.preventDefault();
                      }}
                      className="form-control input-with-icon-left form-control-mobile-sm input-amount"
                      autoComplete="off"
                    />
                    <span className="input-label-rupee">₹</span>
                  </div>
                </div>
                <span className="inputdetail-label label-amount-in-words text-capitalize d-inline-block mb-0">
                  {convertNumberToWords(sumAssured)}
                </span>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 mb-4">
              <div className="form-group mb-2">
                <label className="label label-info-lg" htmlFor="e_shield_policy_term">
                  Policy Term
                </label>
                <div className="d-flex justify-content-between">
                  <span className="pre-label lato-regular font-weight-regular font-12 lh-15 text-gradient mb-1">
                    Min-5 years
                  </span>
                </div>
                <div className="form-data mb-2">
                  <select
                    value={policyTerm}
                    onChange={(e) => setPolicyTerm(Number(e.target.value))}
                    className="form-control form-select form-select-lg"
                  >
                    {Array.from({ length: 67 }, (_, i) => i + 1).map((year) => (
                      <option key={year} value={year}>
                        {year} {year === 1 ? 'Year' : 'Years'}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-group custom-check mb-0">
                <label className="d-flex align-items-start">
                  <div>
                    <span className="mb-0 mr-2" title="Whole life minimum entry age is 45" name="PT_duration">
                      <input type="checkbox" />
                    </span>
                  </div>
                  <p className="lato-medium font-weight-medium h6 lh-17 text-gray mb-0">Whole life</p>
                </label>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-12">
              <label className="label label-info-lg mb-2">Premium Payment Frequency</label>
              <div className="radio-button-block radio-label-with-content mb-3">
                <div className="radio-toolbar">
                  <div className="radio-two">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <input
                              type="radio"
                              id="yearly"
                              name="paymentFrequency"
                              value="Yearly"
                              checked={paymentFrequency === 'Yearly'}
                              onChange={(e) => setPaymentFrequency(e.target.value)}
                            />
                            <label htmlFor="yearly">
                              <span>Yearly</span>
                              <p className="lato-bold font-weight-bold font-10 lh-12 text-secondary-green">
                                Save 2%
                              </p>
                            </label>
                          </td>
                          <td>
                            <input
                              type="radio"
                              id="halfYearly"
                              name="paymentFrequency"
                              value="Half-Yearly"
                              onChange={(e) => setPaymentFrequency(e.target.value)}
                            />
                            <label htmlFor="halfYearly">
                              <span>Half Yearly</span>
                            </label>
                          </td>
                          <td>
                            <input
                              type="radio"
                              id="monthly"
                              name="paymentFrequency"
                              value="Monthly"
                              onChange={(e) => setPaymentFrequency(e.target.value)}
                            />
                            <label htmlFor="monthly">Monthly</label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div className="form-group mb-2">
                <label className="label label-info-lg" htmlFor="e_shield_PPO">
                  Premium Paying Option
                </label>
                <div className="form-data mb-2">
                  <select
                    value={payingOption}
                    onChange={(e) => setPayingOption(e.target.value)}
                    className="form-control form-select form-select-lg select-placeholder has-content"
                  >
                    <option value="0">Select Option</option>
                    <option value="Single">Single</option>
                    <option value="Regular">Regular</option>
                    <option value="LPPT">Limited</option>
                  </select>
                </div>
                <span className="lato-regular font-weight-bold text-gradient font-12 lh-12" style={{ color: '#104C88' }}>
                  Discount of 1.5% applicable
                </span>
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="form-group mb-2">
                <label className="label label-info-lg" htmlFor="e_shield_PPT" style={{ paddingBottom: '9px' }}>
                  Premium Paying Term
                </label>

                {/* <div className="form-data mb-2">
    <select
    value={policyTerm}
    onChange={(e) => setPolicyTerm(Number(e.target.value))}
    className="form-control form-select form-select-lg"
    >
    {Array.from({ length: 67 }, (_, i) => i + 1).map((year) => (
    <option key={year} value={year}>
    {year} {year === 1 ? 'Year' : 'Years'}
    </option>
    ))}
    </select>
    </div> */}
                <div className="form-data mb-2">
                  <select
                    value={premiumTerm}
                    onChange={(e) => setPremiumTerm(Number(e.target.value))}
                    className="form-control form-select form-select-lg"

                  >
                    {Array.from({ length: 67 }, (_, i) => i + 1).map((year) => (
                      <option key={year} value={year}>
                        {year} {year === 1 ? 'Year' : 'Years'}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <p className="lato-regular font-weight-regular font-12 lh-15 text-manatee e_shield_selection e_shield_selection_2 mb-2 d-none text-left px-lg-0 px-3">
            Your <span className="lato-bold font-weight-bold">Premium Paying Term</span> will be same as <span className="lato-bold font-weight-bold">Policy Term</span>
          </p>
          <div className="mt-3 text-center btn-block">
            <div>
              <div className="mb-3 position-relative d-inline-block">
                <i className="icon icon-xs-v1 icon-btn-arrow"></i>
              </div>
              <span className="lato-bold font-weight-bold lato-medium font-weight-medium font-12 lh-15 text-gray d-block">
                Discount is applicable on the Final Premium Payable
              </span>
            </div>
          </div>
        </div>
      </div>


      <div className="col-xl-6 p-lg-3 p-0">
        <h3 className="lato-bold,d-xl-none d-block product-pre-label lato-semibold font-weight-semibold h3 lh-24 text-charcoal text-center mb-lg-3 mb-0 mt-lg-0 mt-2">
          Select Your Plan Cover
        </h3>
        <div className="recommendation-right-arrow position-absolute">
          <i className="icon icon-lg icon-right-arrow"></i>
        </div>
        <div className="plan-options plan-cover pt-lg-0 pt-3">
          <div className="product-plan-card mb-3">
            <input
              id="rdolevelCover"
              type="radio"
              name="product-plan"
              value="rdolevelCover"
              checked={selectedPlan === 'rdolevelCover'}
              onChange={handlePlanChange}
            />
            <label htmlFor="rdolevelCover">
              <h2 className="lato-bold font-weight-bold h4 lh-29 text-charcoal">
                Level Cover
                <div className="vertical-card-radio"></div>
              </h2>
              <p className="text-charcoal" style={{ marginTop: '-8px', marginBottom: '8px', fontSize: '12px' }}>
                Sum Assured remains same throughout the Policy Term
              </p>
              <div className="product-card-contents">
                <div className="d-flex justify-content-between align-items-end">
                  <div className="">
                    <h3 className="lato-medium font-weight-medium lh-20 h6 text-charcoal pb-1 mb-0 premium-duration">
                      Yearly Premium
                    </h3>
                    <span className="lato-medium font-weight-medium font-12 lh-15 text-gray d-block text-right tax-label">
                      (Without taxes)
                    </span>
                    <h3 className="lato-bold font-weight-bold h4 lh-24 text-toryblue mb-0 mt-2 text-right">
                      <span className="mr-1">₹</span>13239
                    </h3>
                  </div>
                  <div className="">
                    <h3 className="lato-medium font-weight-medium lh-20 h6 text-charcoal pb-1 mb-0">
                      Applicable Taxes
                    </h3>
                    <h3 className="mt-lg-4 mt-3 lato-bold font-weight-bold h4 lh-24 text-toryblue mb-0 text-right">
                      <span className="mr-1">₹</span>2383
                    </h3>
                  </div>
                  <div className="plan-cover-total">
                    <h3 className="lato-bold font-weight-bold lh-20 h6 text-charcoal pb-1 mb-0">
                      Total Premium
                    </h3>
                    <span className="lato-medium font-weight-medium font-12 lh-15 text-gray d-block text-right tax-label">
                      (With taxes)
                    </span>
                    <h3 className="lato-bold font-weight-bold h3 lh-24 text-toryblue mb-0 mt-2 text-right">
                      <span className="mr-1">₹</span>15622
                    </h3>
                  </div>
                </div>
              </div>
            </label>
          </div>
          <div className="product-plan-card mb-3">
            <input
              id="rdoIncCover"
              type="radio"
              name="product-plan"
              value="rdoIncCover"
              checked={selectedPlan === 'rdoIncCover'}
              onChange={handlePlanChange}
            />
            <label htmlFor="rdoIncCover">
              <h2 className="lato-bold font-weight-bold h4 lh-29 text-charcoal">
                Increasing Cover
                <div className="vertical-card-radio"></div>
              </h2>
              <h6 className="text-charcoal" style={{ marginTop: '-8px', marginBottom: '8px', fontSize: '12px' }}>
                Sum Assured increases by 10% at the end of every 5th Policy year.
              </h6>
              <div className="product-card-contents">
                <div className="d-flex justify-content-between align-items-end">
                  <div className="">
                    <h3 className="lato-medium font-weight-medium lh-20 h6 text-charcoal pb-1 mb-0 premium-duration">
                      Yearly Premium
                    </h3>
                    <span className="lato-medium font-weight-medium font-12 lh-15 text-gray d-block text-right tax-label">
                      (Without taxes)
                    </span>
                    <h3 className="lato-bold font-weight-bold h4 lh-24 text-toryblue mb-0 mt-2 text-right">
                      <span className="mr-1">₹</span>18516
                    </h3>
                  </div>
                  <div className="">
                    <h3 className="lato-medium font-weight-medium lh-20 h6 text-charcoal pb-1 mb-0">
                      Applicable Taxes
                    </h3>
                    <h3 className="mt-lg-4 mt-3 lato-bold font-weight-bold h4 lh-24 text-toryblue mb-0 text-right">
                      <span className="mr-1">₹</span>3333
                    </h3>
                  </div>
                  <div className="plan-cover-total">
                    <h3 className="lato-bold font-weight-bold lh-20 h6 text-charcoal pb-1 mb-0">
                      Total Premium
                    </h3>
                    <span className="lato-medium font-weight-medium font-12 lh-15 text-gray d-block text-right tax-label">
                      (With taxes)
                    </span>
                    <h3 className="lato-bold font-weight-bold h3 lh-24 text-toryblue mb-0 mt-2 text-right">
                      <span className="mr-1">₹</span>21849
                    </h3>
                  </div>
                </div>
              </div>
            </label>
          </div>
          <div className="product-plan-card mb-lg-0 mb-3">
            <input
              id="rdolevelCoverAndFutureBenefits"
              type="radio"
              name="product-plan"
              value="rdolevelCoverAndFutureBenefits"
              checked={selectedPlan === 'rdolevelCoverAndFutureBenefits'}
              onChange={handlePlanChange}
            />
            <label htmlFor="rdolevelCoverAndFutureBenefits">
              <div className="d-flex align-items-baseline">
                <h2 className="lato-bold font-weight-bold h4 lh-29 text-charcoal mb-0">
                  Level Cover with Future Proofing Benefit
                  <div className="vertical-card-radio"></div>
                </h2>
              </div>
              <h6 className="text-charcoal" style={{ marginTop: '-8px', marginBottom: '8px', fontSize: '12px' }}>
                Choice to increase Sum Assured on attaining certain life stages during the policy term. Additional Premium to be paid only if Sum Assured increases in future
              </h6>
              <div className="product-card-contents">
                <div className="d-flex justify-content-between align-items-end">
                  <div className="">
                    <h3 className="lato-medium font-weight-medium lh-20 h6 text-charcoal pb-1 mb-0 premium-duration">
                      Yearly Premium
                    </h3>
                    <span className="lato-medium font-weight-medium font-12 lh-15 text-gray d-block text-right tax-label">
                      (Without taxes)
                    </span>
                    <h3 className="lato-bold font-weight-bold h4 lh-24 text-toryblue mb-0 mt-2 text-right">
                      <span className="mr-1">₹</span>13239.00
                    </h3>
                  </div>
                  <div className="">
                    <h3 className="lato-medium font-weight-medium lh-20 h6 text-charcoal pb-1 mb-0">
                      Applicable Taxes
                    </h3>
                    <h3 className="mt-lg-4 mt-3 lato-bold font-weight-bold h4 lh-24 text-toryblue mb-0 text-right">
                      <span className="mr-1">₹</span>2383
                    </h3>
                  </div>
                  <div className="plan-cover-total">
                    <h3 className="lato-bold font-weight-bold lh-20 h6 text-charcoal pb-1 mb-0">
                      Total Premium
                    </h3>
                    <span className="lato-medium font-weight-medium font-12 lh-15 text-gray d-block text-right tax-label">
                      (With taxes)
                    </span>
                    <h3 className="lato-bold font-weight-bold h3 lh-24 text-toryblue mb-0 mt-2 text-right">
                      <span className="mr-1">₹</span>15622.00
                    </h3>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
      {/* <div className="addons-summary bg-alice-blue br-8">
        <h3 className="lato-medium font-weight-medium h3 lh-24 text-charcoal mb-lg-4 mb-3 text-center sub-heading-v2">
        Your Premium (with tax) bifurcation as follows
        </h3>
        <div className="addons-summary-table d-flex justify-content-between align-items-start flex-lg-row flex-column">
        <div className="selected-plan-cover summary-data">
        <h3 className="lato-regular font-weight-regular h5 lh-20 text-charcoal text-lg-center text-left">
        <span>Level Cover with Future Proofing Benefit</span><span className="mr-1">*</span>
        </h3>
        <h3 className="lato-bold font-weight-bold h3 lh-24 text-toryblue mb-0 mt-2 text-lg-center text-right pr-lg-0 pr-3">
        <span className="mr-1">₹</span><span>15622.00</span>
        </h3>
        </div>
        <div className="vertical-radio-checkbox-detail-icon align-self-center text-center">
        <i className="icon icon-sm icon-plus-v2"></i>
        </div>
        <div className="better-half-benefit summary-data">
        <h3 className="lato-regular font-weight-regular h5 lh-20 text-charcoal text-lg-center text-left">
        Better Half Benefit<span className="mr-1">*</span>
        </h3>
        <h3 className="lato-bold font-weight-bold h3 lh-24 text-toryblue mb-0 mt-2 text-lg-center text-right pr-lg-0 pr-3">
        <span className="mr-1">₹</span><span>0</span>
        </h3>
        </div>
        <div className="vertical-radio-checkbox-detail-icon align-self-center text-center">
        <i className="icon icon-sm icon-plus-v2"></i>
        </div>
        <div className="acc-death-benefit-rider summary-data">
        <h3 className="lato-regular font-weight-regular h5 lh-20 text-charcoal text-lg-center text-left">
        Accidental Death Benefit Rider<span className="mr-1">*</span>
        </h3>
        <h3 className="lato-bold font-weight-bold h3 lh-24 text-toryblue mb-0 mt-2 text-lg-center text-right pr-lg-0 pr-3">
        <span className="mr-1">₹</span><span>0</span>
        </h3>
        </div>
        <div className="vertical-radio-checkbox-detail-icon align-self-center text-center">
        <i className="icon icon-sm icon-plus-v2"></i>
        </div>
        <div className="acc-perm-disability summary-data">
        <h3 className="lato-regular font-weight-regular h5 lh-20 text-charcoal text-lg-center text-left">
        Accidental Total & Permanent Disability Benefit Rider<span className="mr-1">*</span>
        </h3>
        <h3 className="lato-bold font-weight-bold h3 lh-24 text-toryblue mb-0 mt-2 text-lg-center text-right pr-lg-0 pr-3">
        <span className="mr-1">₹</span><span>0</span>
        </h3>
        </div>
        <div className="vertical-radio-checkbox-detail-icon align-self-center text-center d-lg-block">
        <i className="icon icon-sm icon-equal-v2"></i>
        </div>
        <div className="summary-total-premium summary-data">
        <div className="summary-data-total">
        <h3 className="h4 lh-20 text-charcoal text-lg-right text-left total-premium-duration">
        Final Premium Payable
        </h3>
        <span className="lato-bold font-weight-bold lato-medium font-weight-medium font-12 lh-15 text-gray d-block">
        (with Discount)
        </span>
        </div>
        <h3 className="lato-bold font-weight-bold h3 lh-24 mb-0 mt-2 text-right bg-pacific-blue text-white">
        <span className="mr-1">₹</span><span>15389</span>
        </h3>
        </div>
        </div>
        </div> */}
      {/* <div>
<h4 className="lato-regular font-weight-regular h3 lh-24 text-charcoal mb-4 sub-heading-v2 px-lg-0 px-3">
How would you like your family to receive the benefits after you
<span className="lato-regular font-weight-regular h5 lh-20 text-gray align-middle">
(Select any one option)
</span>
</h4>

<div className="plan-option plan-options-xl d-flex align-items-start justify-content-between">
<div className="product-plan-card">
<input
id="lumsum"
type="radio"
name="plan-option"
value="lumsum"
defaultChecked
/>
<label htmlFor="lumsum">
<div className="d-flex align-items-center justify-content-center flex-column">
<div className="vertical-card-radio"></div>
<i className="icon icon-md icon-lumsum-amount mb-2"></i>
<h5 className="lato-regular font-weight-regular h4 lh-22 text-charcoal mb-lg-2 mb-1">Lumpsum</h5>
<p className="lato-regular font-weight-regular h6 lh-17 text-light-gray">
Lumpsum payout of <span className="mr-1">₹</span><span>10000000</span>
</p>
</div>
</label>
</div>
<div className="product-plan-card">
<input
id="regularmonthlyinstallment"
type="radio"
name="plan-option"
value="regularmonthlyinstallment"
/>
<label htmlFor="regularmonthlyinstallment">
<div className="d-flex align-items-center justify-content-center flex-column">
<div className="vertical-card-radio"></div>
<i className="icon icon-md icon-regular-installment mb-2"></i>
<h5 className="lato-regular font-weight-regular h4 lh-22 text-charcoal mb-lg-2 mb-1">Regular Monthly Installments</h5>
<p className="lato-regular font-weight-regular h6 lh-17 text-light-gray">
Regular monthly income of <span className="mr-1">₹</span><span>181000</span> per month for 5 years
</p>
</div>
</label>
</div>
<div className="product-plan-card">
<input
id="lumsum_and_regular"
type="radio"
name="plan-option"
value="lumsum_and_regular"
/>
<label htmlFor="lumsum_and_regular">
<div className="d-flex align-items-center justify-content-center flex-column">
<div className="vertical-card-radio"></div>
<i className="icon icon-md icon-lumsum-regular mb-2"></i>
<h5 className="lato-regular font-weight-regular h4 lh-22 text-charcoal mb-lg-2 mb-1">Lumpsum + Regular Monthly Installments</h5>
<p className="lato-regular font-weight-regular h6 lh-17 text-light-gray">
Lumpsum payout of <span className="mr-1">₹</span><span>5000000</span> + Regular monthly income of
<span className="mr-1">₹</span><span>90500</span> per month for 5 years
</p>
</div>
</label>
</div>
</div>
</div> */}
      <div>
        <div className="text-center" style={{ marginTop: '30px' }}>
          <div className="mb-3 position-relative d-inline-block">

            <button
              id="btnCalculatePremium"
              className="primary-btn primary-btn-right-icon"
              href=""
              onClick={handlesubmit}

            >
              Submit
              <div className="btn-arrow">
                <i className="icon icon-xs-v1 icon-btn-arrow"></i>
              </div>

            </button>

          </div>
        </div>
      </div>
    </>
  );


}

export default Insuranceform;